import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './queries';

export const networkMovementPreferencesApi = createApi({
  reducerPath: 'networkMovementPreferencesApi',
  baseQuery,
  tagTypes: ['network-movement-preferences'],
  endpoints: (builder) => ({
    getNetworkMovementPreferences: builder.query({
      query: () => ({ url: '/me/network_movement_preferences', options: { version: 'v2' } }),
      providesTags: ['network-movement-preferences'],
    }),
    updateNetworkMovementPreference: builder.mutation({
      query: ({ collectionId, enabled }) => ({
        url: `/me/network_movement_preferences/${collectionId}`,
        method: 'PUT',
        data: { enabled },
        options: { version: 'v2' },
      }),
      async onQueryStarted({ collectionId, enabled }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          networkMovementPreferencesApi.util.updateQueryData('getNetworkMovementPreferences', undefined, (draft) => {
            const pref = draft?.data?.find((p) => p.collectionId === collectionId);
            if (pref) {
              pref.enabled = enabled;
            }
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const { useGetNetworkMovementPreferencesQuery, useUpdateNetworkMovementPreferenceMutation } =
  networkMovementPreferencesApi;
